import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { InviteFriendModalModule } from 'AccountsApp/ts/features/invite-friend-modal/invite-friend-modal.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { RefreshRequiredModalModule } from 'Angular/features/components/modals/refresh-required-modal/refresh-required-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { StringPipesModule } from 'Angular/features/pipes/string/string-pipes.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';

import { ImpersonationMenuComponent } from './impersonation-menu/impersonation-menu.component';
import { NavMenuListComponent } from './nav-menu-list/nav-menu-list.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { ImpersonationTargetUserListComponent } from 'Angular/features/components/navigation/impersonation-target-user-list/impersonation-target-user-list.component';

/**
 * The non standalone internals of the top bar nav (menu lists, user menu, impersonation).
 * Kept in their own module so the standalone TopBarNavComponent can import them without a
 * circular file dependency on NavigationModule (which re-exports `TopBarNavComponent`).
 */
@NgModule({
    imports: [
        BaseAutocompleteModule,
        CommonModule,
        FormsModule,
        IconModule,
        InviteFriendModalModule,
        RefreshRequiredModalModule,
        StringPipesModule,
        TooltipModule,
        LoadingSymbolModule,
    ],
    declarations: [
        NavMenuListComponent,
        UserMenuComponent,
        ImpersonationMenuComponent,
        ImpersonationTargetUserListComponent,
    ],
    exports: [NavMenuListComponent, UserMenuComponent],
})
export class NavigationInternalsModule {}
